<template>
  <div class="dsfa-netcom-detail-more">
    <div class="item-list">
      <div class="more-tabs">
        <div class="more-tab-navs" v-if="detailParams.tabNav">
          <div
            :class="['more-tab-nav', detailName == item.code && 'active']"
            v-for="(item, index) in detailParams.tabNav"
            :key="index"
            @click="handleTabNav(item)"
          >
            <span v-if="item.enableValue == 1">{{ item.name }}</span>
          </div>
        </div>
        <div :class="['more-tab-plans', showPlan && 'active']">
          <div class="more-tab-plan" v-show="detailName == 'announcement'">
            <DsfVirtualScroll>
              <ul class="notice-list" v-if="detailParams.announcementList.length > 0">
                <li
                  :class="['notice-item', { active: listId == item.id }]"
                  v-for="(item, index) in detailParams.announcementList"
                  :key="index"
                  @click="handleNotice(item)"
                >
                  <span class="more-tab-plan-title ellipsis">
                    {{ item.title }}
                  </span>
                  <span class="more-tab-plan-time">
                    {{ dsf.date.format(item.dsCreateTime, "yyyy-mm-dd") }}
                  </span>
                </li>
              </ul>
              <DsfEmptyData v-else></DsfEmptyData>
            </DsfVirtualScroll>
          </div>
          <div class="more-tab-plan" v-show="detailName == 'downloads'">
            <DsfVirtualScroll>
              <ul class="notice-list" v-if="detailParams.downloadsList.length > 0">
                <li
                  :class="['notice-item', { active: listId == item.id }]"
                  v-for="(item, index) in detailParams.downloadsList"
                  :key="index"
                  :title="item.title"
                  @click="handleDownload(item)"
                >
                  <span class="more-tab-plan-title ellipsis">
                    {{ item.title }}
                  </span>
                  <span class="more-tab-plan-time">
                    {{ dsf.date.format(item.fileUpload.uploadDate, "yyyy-mm-dd") }}
                  </span>
                </li>
              </ul>
              <DsfEmptyData v-else></DsfEmptyData>
            </DsfVirtualScroll>
          </div>
        </div>
      </div>
    </div>
    <div class="item-info">
      <div v-if="detail" class="detail">
        <h2 class="title" v-if="detail.title">
          {{ detail.title }}
        </h2>
        <p class="time" v-if="detail.date">
          {{ detail.date }}
        </p>
        <div class="content" v-if="detail.content">
          <DsfVirtualScroll style="padding-right: 10px;">
            <div v-if="detail.content" v-html="detail.content"></div>
            <div class="notice-line"></div>
            <div class="detail-file" v-if="detail.fileUpload && detail.fileUpload.length">
              <p v-for="list in detail.fileUpload" :key="list.id">附件：<span :title="list.originalFileName" @click="downLoadFn(list)" class="fj">{{  list.originalFileName }}</span></p>
            </div>
          </DsfVirtualScroll>
        </div>
        <div class="qr-code" v-if="detail.qrCode">
          <p class="text">{{ detail.describe }}</p>
          <el-image class="qr-img" :src="dsf.url.getWebPath(detail.qrCode)" fit="cover"></el-image>
          <div class="qrcode-text">{{ detail.title }}</div>
        </div>
      </div>
      <DsfEmptyData v-else></DsfEmptyData>
    </div>
    <div class="dsfa-netcom-close" @click="close()"><i class="iconfont icon-guanbi2"></i></div>
  </div>
</template>

<script>
export default {
  name: "NetcomDetailMore",
  props: {
    detailParams: {
      type: Object,
      default() {
        return {
          activeName: "",
          noticeId: "",
          tabNav: "",
          announcementList: "",
          downloadsList: "",
        };
      },
    },
  },
  data() {
    return {
      // tabNav: [],
      // announcementList: [],
      // downloadsList: [],
      showPlan: false,
      listId: "",
      detail: "",
      detailName: "",
    };
  },
  watch: {},
  components: {},
  computed: {},
  created() {
    this.detailName = this.detailParams.activeName;
    this.handleTabNav({
      code: this.detailParams.activeName
    });
    // this.init();
  },
  methods: {
    // async init() {
    //   await this.getNavs();
    //         this.handleTabNav({
    //     code: this.activeName,
    //   });
    // },
    async getNavs() {
      await dsf.http
        .get(`/downloads/getGateWaySetting`)
        .done(({ data, success, message }) => {
          if (success) {
            // 排序 按照后端返回顺序 显示前 隐藏后
            let tabNav = [];
            let shownav = [];
            let hidenav = [];
            _.each(data, (item) => {
              item.enableValue == 1 ? shownav.push(item) : hidenav.push(item);
            });
            tabNav = shownav.filter((item) => item.code !== "wiki");
            this.tabNav = tabNav;
            // this.activeName = tabNav[0]?.code;
            // this.show = tabNav[0]?.enableValue == 1;
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    getNoticeList() {
      let status = this.tabNav.find((it) => {
        return it.code == "announcement";
      })?.enableValue;
      if (status != 1) {
        return true;
      }
      let params = {
        pageNum: 1,
        pageSize: 100,
      };
      dsf.http
        .get(`/announce/getMessageList`, params)
        .done(({ data, success, message }) => {
          if (success) {
            if (data.list?.length) {
              this.announcementList = data.list;
              this.handleNotice(data.list[0]);
            }
          }
        })
        .error((err) => {})
        .always(() => {});
    },
    getDownloadeList() {
      let status = this.tabNav.find((it) => {
        return it.code == "downloads";
      })?.enableValue;
      if (status != 1) {
        return true;
      }
      let params = {
        pageNum: 1,
        pageSize: 100,
      };
      dsf.http
        .get(`/downloads/getDownloads`, params)
        .done(({ data, success, message }) => {
          if (success) {
            if (data.length) {
              this.downloadsList = data;
              this.handleDownload(data[0]);
            }
          }
        })
        .error((err) => {})
        .always(() => {});
    },

    handleTabNav(item) {
      this.showPlan = true;
      this.detailName = item.code;
      this.detail = "";
      if (item.code == "announcement") {
        //  有传ID直接查询，没传默认更多 显示第一条
        if (this.detailParams.noticeId) {
          this.handleNotice({
            id: this.detailParams.noticeId,
          });
        } else {
          if (this.detailParams.announcementList.length) {
            this.handleNotice(this.detailParams.announcementList[0]);
          }
        }
      } else {
        if (this.detailParams.downloadsList.length) {
          this.handleDownload(this.detailParams.downloadsList[0]);
        }
      }
    },
    handleNotice(item) {
      this.listId = item?.id;
      // let loadVm = dsf.layer.loading();
      let params = {
        id: item?.id,
      };
      this.$http
        .get(`/announce/getDetailById`, params)
        .done(({ data, success, message }) => {
          if (success) {
            this.detail = data;
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          if (err) {
            dsf.layer.message(err.message || "未知错误", false);
          }
        })
        .always(() => {
          // dsf.layer.closeLoading(loadVm);
        });
    },
    handleDownload(item) {
      this.listId = item.id;
      this.detail = item;
    },
    downLoadFn(row) {
      dsf.file.download.call(
          this,
          "/file/download",
          {
            files: row.id,
            zipName: row.name
          },
          row.originalFileName,
          true
        );
    },
    close() {
      this.$emit("detail-close", false);
    },
  },
};
</script>
